/* eslint-disable camelcase */
import React from "react"
import { useCustomName } from "hooks"
import { DEPARTMENT_KEY, FACILITY_KEY } from "utils/customNameHelpers"
import { auditShape } from "utils/propTypeShapes"
import { AuditedUser } from "shared/audits"

const externalIdDescription = ({ external_identifier }) => {
  if (!external_identifier) return null

  return (
    <>with external identifier <span className="italic">{external_identifier}</span></>
  )
}

const DepartmentCreated = ({ audit }) => {
  const { auditedChanges, comment } = audit
  const { name } = auditedChanges

  const { nameInSentence: facilityNameInSentence } = useCustomName(FACILITY_KEY)
  const { nameInSentence: departmentNameInSentence } = useCustomName(DEPARTMENT_KEY)

  return (
    <div>
      <span>
        <AuditedUser audit={audit} /> added {departmentNameInSentence} <span className="font-semibold">{name}</span> to
        the {facilityNameInSentence} {externalIdDescription(auditedChanges)} {comment}
      </span>
    </div>
  )
}

DepartmentCreated.propTypes = {
  audit: auditShape.isRequired,
}

export default DepartmentCreated
